module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"recent":"Aberto recentemente","noRecent":"Nenhum item aberto recentemente"},"en":{"recent":"Recently opened","noRecent":"No recent items"}}')
  delete Component.options._Ctor
}
